import { FC } from 'react';
import Monitoring from '../../Monitoring/ui/Monitoring';

const Reporting: FC = () => <Monitoring />;

export default Reporting;
